<template>
    <div class="detail__add">
        <img v-if="showImg" class="detail__add_left" :src="showImgFn" />
        <div class="detail__add_right">
            <div class="detail__add_right__title">{{title}}</div>
            <div class="detail__add_right__desc">
                <div>{{cartData.price === '' ? data.price : cartData.price}}</div>
                <div>库存 {{(chose.color === 0 && !chose.surface && !chose.size) ? data.stock : cartData.stock}}</div>
            </div>
            <div class="detail__add_right__color">
                <div>颜色</div>
                <div>{{choseIndex}}</div>
            </div>
            <div class="detail__add_right__color_more">
                <div class="detail__add_right__color_more__box" 
                :class="chose.color === item.id ? 'detail__add_right__color_more__box__common_chose' : item.status ? '' : 'detail__add_right__color_more__box__common_nochose'" 
                v-for="(item,index) in cart.color" :key='index' 
                @click="onChoseColor(item.id,item.status,index)">
                    <img :src='item.image' class="detail__add_right__color_more__box__common"  />
                </div>
            </div> 
            <div class="detail__add_right__color detail__add_right__color__special"> 
                <div>表面</div>
            </div>
            <div class="detail__add_right__color_more">
                <div class="detail__add_right__surface__box" 
                :class="chose.surface === item.title ? 'detail__add_right__color_more__box__common_chose' : item.status ? '' : 'detail__add_right__color_more__box__common_nochose'" 
                v-for="(item,index) in cart.surface" :key='index' 
                @click="onChoseSurface(item.title, item.status)">
                    <div class="detail__add_right__btn">{{item.title}}</div>
                </div>
            </div>
            <div class="detail__add_right__color detail__add_right__size" >
                <div>规格 cm</div>
            </div>
            <div class="detail__add_right__color_more">
                <div class="detail__add_right__surface__box" 
                :class="chose.size === item.title ? 'detail__add_right__color_more__box__common_chose' : item.status ? '' : 'detail__add_right__color_more__box__common_nochose'" 
                v-for="(item,index) in cart.size" :key='index' 
                @click="onChoseSize(item.title, item.status)">
                    <div class="detail__add_right__btn">{{item.title}}</div>
                </div>
            </div>
            <!-- <div class="detail__add_right__color detail__add_right__size">
                <div>数量</div>
            </div>
            <div class="detail__add_right__number"> 
                <div>{{(chose.color === 0 || !chose.surface || !chose.size) ? 0 : (cartData.area * cartData.num).toFixed(2) }}平米</div>
                <el-input-number v-model="cartData.num" @change="onHandleChange" :min="0" :max="(chose.color === 0 && !chose.surface && !chose.size) ? data.stock : cartData.stock" label="描述文字"></el-input-number>
            </div> -->
            <!-- <div class="detail__add_right__foot">
                <div @click="onAddShop">加入购物车</div>
                <div>订单将在付款后的3日内发货，大额订单会致电确认，请保持电话畅通</div>
            </div> -->
        </div>
    </div>
</template>
<script>
import "./index.scss";

	export default {
		data() {
			return {
				choseIndex:''
			}
        },
        props: ['chose','title','data','showImg','cart','cartData'],
		computed: {
			showImgFn(){
                return this.showImg.split('?')[0]
            }
		},
        created(){
            
        },
		mounted() {
        },
        watch:{

        },
		methods: {
            onChoseColor(id,status,index){
                console.log('dayin1yixa00000',this.cart)
                if (!status) return
                this.choseIndex = this.choseIndex === '' ? this.cart.color[index].title === undefined ? `${this.cart.color[index].en}（${this.cart.color[index].cn}）` : this.cart.color[index].title : ''
                this.$emit('onChoseColor',id,status,index)
            },
            onChoseSurface(title,status){
                this.$emit('onChoseSurface',title,status)
            },
            onChoseSize(title,status){
                this.$emit('onChoseSize',title,status)
            },
            onHandleChange(currentValue, oldValue){
                this.$emit('onHandleChange',currentValue)
            },
            onAddShop(){
                this.$emit('onAddShop')
            }
        }
	}
</script>
<style lang="scss">
    .el-input-number{
        width: 95px;
        height: 24px;
        display: flex;
        align-items: center;
    }
    .el-input-number__decrease{
        width: 24px;
        height: 24px;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
    }
    .el-input-number__increase{
        width: 24px;
        height: 24px;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
    }
    .el-input-number .el-input{
        width: 39px;
        height: 24px;
        background:rgba(241,241,241,1);
        border-radius:4px;
        margin: 0 28px 0 28px;
    }
    .el-input-number .el-input__inner{
        padding: 0;
        border: none;
        width: 39px;
        height: 24px;
        line-height: 24px;
        background:rgba(241,241,241,1);
        border-radius:4px;
    }
</style>
